import { CircleNotch, PaperPlaneRight, X, ArrowRight } from '@phosphor-icons/react';

interface SendButtonProps {
    numOfLines: number;
    isSending: boolean;
    isStoppable: boolean;
    stopStream: any;
    sendMessageHandler: () => void;
    buttonStyle?: boolean;
    visibilityClass?: string;
}

export default function SendButton({
    numOfLines,
    isSending,
    isStoppable,
    stopStream,
    sendMessageHandler,
    buttonStyle = true,
    visibilityClass = '',
}: SendButtonProps) {
    return (
        <>
            {buttonStyle ? (
                <div
                    className={`${visibilityClass} text-layout-textcolor overflow-hidden  flex justify-center items-center transition-all flex items-center h-[56px] w-[56px] duration-300
                        ${numOfLines > 2 ? 'rotate-[-90deg]' : 'rotate-0'}`}
                >
                    <button
                        className={`rounded-full h-[46px] w-[46px] transition-all duration-100 text-chatInput-sendButtonColor bg-chatInput-sendButtonBackground hover:bg-chatInput-sendButtonBackground-hover border-none flex items-center justify-center`}
                        onClick={isSending ? (isStoppable ? stopStream : () => {}) : () => sendMessageHandler()}
                    >
                        {isSending ? (
                            isStoppable ? (
                                <X size={24} />
                            ) : (
                                <CircleNotch size={24}>
                                    <animateTransform
                                        attributeName="transform"
                                        type="rotate"
                                        from="0 0 0"
                                        to="360 0 0"
                                        dur="1s"
                                        repeatCount="indefinite"
                                    />
                                </CircleNotch>
                            )
                        ) : (
                            <ArrowRight size={24} />
                        )}
                    </button>
                </div>
            ) : (
                <div
                    className={`${visibilityClass} h-[60px] overflow-hidden w-[40px] bg-transparent text-layout-textcolor flex justify-center items-center cursor-pointer transition-all duration-100  ${
                        numOfLines > 1 ? 'rounded-tl rounded-br' : 'rounded-e-md'
                    } ${buttonStyle ? 'pr-0' : 'pr-2'}`}
                >
                    <button
                        className="border-none text-chatInputHome-mobileSendButtonColor rounded-s bg-transparent h-full w-full flex items-center justify-center text-chatInputHome-mobileSendButtonColor"
                        onClick={isSending ? (isStoppable ? stopStream : () => {}) : () => sendMessageHandler()}
                    >
                        {isSending ? (
                            isStoppable ? (
                                <span className="hover:text-primary transition-all duration-100">
                                    <X size={24} />
                                </span>
                            ) : (
                                <span className="hover:text-primary transition-all duration-100">
                                    <CircleNotch size={24}>
                                        <animateTransform
                                            attributeName="transform"
                                            type="rotate"
                                            from="0 0 0"
                                            to="360 0 0"
                                            dur="1s"
                                            repeatCount="indefinite"
                                        />
                                    </CircleNotch>
                                </span>
                            )
                        ) : (
                            <span className="hover:text-primary transition-all duration-100">
                                <PaperPlaneRight size={24} />
                            </span>
                        )}
                    </button>
                </div>
            )}
        </>
    );
}
